import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { movieVM } from '../../models/movieVM';
import { AppConstants } from '../../constants/siteConstants';


@Injectable()
export class MovieTimingService {
  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<movieVM[]>(`${AppConstants.baseURL}/movie/movies/`);
  }

  getById(id: number) {
    return this.http.get(`${AppConstants.baseURL}/users/` + id);
  }

  addMovieTimings(user: any) {
    debugger;
    return this.http.post(`${AppConstants.baseURL}/movie/saveMovieVenues`, user);
  }

  update(model: any) {
    return this.http.post(`${AppConstants.baseURL}/movie/updateMovieVenues`, model);
    // return this.http.get(`${AppConstants.baseURL}/movie/updateMovieVenues` + movieId + "?venueId=" + venueId + "?venueName=" + venueName);
  }

  delete(id: number) {
    return this.http.delete(`${AppConstants.baseURL}/users/` + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/movie/movieTiming.service.ts